var map = {
	"./android/Device": 984,
	"./androidtv/Device": 1174,
	"./arris/Device": 1179,
	"./hisense/Device": 1190,
	"./lg/Device": 1198,
	"./nagra/Device": 1207,
	"./netrange/Device": 1218,
	"./opera/Device": 1226,
	"./polaroid/Device": 1234,
	"./ps4/Device": 1242,
	"./samsung/Device": 1250,
	"./seirobotics/Device": 1258,
	"./sony/Device": 1263,
	"./stbcoship/Device": 1271,
	"./stbcoship9108/Device": 1275,
	"./stbhuawei/Device": 1279,
	"./stbkaon/Device": 1283,
	"./tizen/Device": 1286,
	"./web0s/Device": 1295,
	"./workstation/Device": 618,
	"./workstationChafari/Device": 1309,
	"./zeasn/Device": 1317,
	"./zte/Device": 1325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 983;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 983
// module chunks = 0